import { render, staticRenderFns } from "./EstimateTaskItemBuild.vue?vue&type=template&id=3d48be42&"
import script from "./EstimateTaskItemBuild.vue?vue&type=script&lang=js&"
export * from "./EstimateTaskItemBuild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports